import React, { type ReactNode } from 'react';
import ToolTip from '@atlaskit/tooltip';
import { Summary } from '../../../styled.tsx';

type StaticSummaryFieldProps = {
	summary: string;
	highlightText: ReactNode | null;
};

export const StaticSummaryField = ({ summary, highlightText }: StaticSummaryFieldProps) => (
	<ToolTip content={summary}>
		<Summary>{highlightText ?? summary}</Summary>
	</ToolTip>
);
